import { plainToClass } from 'class-transformer';
import {
  API_SKILL_FIND_ALL,
  API_SKILL_FIND_ONE,
  API_SKILL_CREATE,
  API_SKILL_UPDATE,
  API_SKILL_DELETE
} from '../api.routes';
import { BaseApi } from './base.api';
import { SkillDto } from '../dto';
import { FindAllResponse } from '../types';

export class SkillApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<SkillDto>> {
    return this.httpClient
      .get(API_SKILL_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(SkillDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<SkillDto> {
    return this.httpClient
      .get(API_SKILL_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(SkillDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<SkillDto> {
    return this.httpClient.post(API_SKILL_CREATE, data).then(({ data }) => {
      return plainToClass(SkillDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<SkillDto> {
    return this.httpClient.put(API_SKILL_UPDATE, data).then(({ data }) => {
      return plainToClass(SkillDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_SKILL_DELETE, {
      pathParams: { uuid }
    });
  }
}
